import { generatePath, Link } from 'react-router-dom';
import { DOSSIER_DETAIL_PATH } from '../../../constants/paths.constants';
import { dateToDateString } from '../../../lib/date.utils';

const HeaderNotificationsList = ({ notifications = [], canLoadMore }) => {
  return (
    <ul className="a-list a-list--reset">
      {notifications.length ? (
        notifications?.map((notification) => (
          <li key={notification.id}>
            <p className="u-flex u-flex-justify-space-between">
              <Link to={generatePath(DOSSIER_DETAIL_PATH, { id: notification.dossierId || '123' })}>
                {notification.dossierNumber}
              </Link>
              <div className="u-flex u-flex-align-center">
                <span className={`u-text-light notification-date ${!notification.acknowledged ? 'u-text-bold' : ''}`}>
                  {dateToDateString(notification.createdAt, true)}
                </span>
                {!notification.acknowledged && <div className="unread-dot"></div>}
              </div>
            </p>
            {notification?.showAsHtml ? (
              <p
                className={!notification.acknowledged ? 'u-text-bold' : ''}
                dangerouslySetInnerHTML={{ __html: notification.message }}
              ></p>
            ) : (
              <p className={!notification.acknowledged ? 'u-text-bold' : ''}>{notification.message}</p>
            )}
          </li>
        ))
      ) : (
        <li>Er zijn geen notificaties.</li>
      )}
      {canLoadMore && (
        <li>
          <span className="u-text-light">Meer</span>
        </li>
      )}
    </ul>
  );
};

export default HeaderNotificationsList;
